module.exports = __webpack_public_path__ + "static/a4-8078e54cb9790e4679481a2796125ad0.png";